import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { MerchantService } from '../../../models/merchant/merchantService';
import {
  TextModes,
} from '../../ui/controls/text-input/text-input.component';
import {
  FormValidator,
  ValidationMessage,
} from '../../../models/validation/formValidator';
import { iValidatedControl } from '../../ui/controls/iValidatedControl';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from '../../baseComponent';
import { ContactType, FormMode } from '../../../core/constants';
import { AssignedUser } from '../../../models/users/assignedUser';
import { Textbox } from '../../../../../../../libs/Shared/components/inputs/textbox/textbox';
import { Selectbox } from '../../../../../../../libs/Shared/components/inputs/selectbox/selectbox';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { ContactDialogComponent } from '../../ui/dialogs/contact-dialog/contact-dialog.component';
import { AddMerchantContactDialogComponent } from './add-merchant-contact-dialog.component';
@Component({
  selector: 'app-merchant-contact',
  templateUrl: './merchant-contact.component.html',
  standalone: false,
})
export class MerchantContactComponent extends BaseComponent {
  @Input() headerText: string = 'Contact Information';
  @Input() contacts: AssignedUser[] = [];
  @Input() merchantId: string = '';
  @Input() enableEditing: boolean = false;
  @Input() mode: FormMode = FormMode.View;
  @Input() enableDataStore: boolean = false;
  @Output() onsave = new EventEmitter<boolean>();
  @Output() ondelete = new EventEmitter<boolean>();

  @ViewChildren(Textbox) validatedTextBoxes:
    | QueryList<Textbox>
    | undefined;
  @ViewChildren(Selectbox) validatedDropDowns:
    | QueryList<Selectbox>
    | undefined;

  inputTextModes = TextModes;

  editingContact: boolean = false;

  contactTypeOptions = AssignedUser.ALL_CONTACT_TYPES;
  contactsInitialState: AssignedUser[] = [];
  contactsToDelete: AssignedUser[] = [];

  savingContacts: boolean = false;
  

  constructor(
    public contactDialog: MatDialog,
    public merchantService: MerchantService,
    private formValidator: FormValidator,
    private uiErrorHandler: UIErrorHandler,
    private dialog: MatDialog,
  ) {
    super();
  }

  ngOnInit() { 
    //Sort the contacts to put primary contacts first otherwise sort by last name
    this.contacts.sort((a, b) => {
      if (a.contactTypes.includes(ContactType.Primary)) {
        return -1;
      }
      if (b.contactTypes.includes(ContactType.Primary)) {
        return 1;
      }
      return a.lastName.localeCompare(b.lastName);
    });
    this.contactsInitialState = this.contacts;
  }

  handleFirstNameChanged(event: Event) {
    console.log(event);
  }

  public validate(): ValidationMessage[] {
    let errors: ValidationMessage[] = [];

    let validatedControls: iValidatedControl[] = [];
    if (this.validatedTextBoxes && this.validatedDropDowns) {
      validatedControls = validatedControls.concat(
        this.validatedTextBoxes.toArray(),
      );
      validatedControls = validatedControls.concat(
        this.validatedDropDowns.toArray(),
      );

      errors = this.formValidator.validate(validatedControls);
    }

    return errors;
  }

  handleAddAnotherContact() {
    const newContact = AssignedUser.createEmpty();
    this.contacts.push(newContact);
  }

  async handleRemoveContact(contact: AssignedUser) {
    const message = `Are you sure you want to remove ${contact.firstName} ${contact.lastName} as a contact?  If so, click OK and then save the changes with the save button at the bottom of the page.`;
    if (!confirm(message)) {
      return
    }

    try {
      this.savingContacts = true;
      await this._removeContact(contact);
      this.contacts = this.contacts.filter(c => c !== contact);
      this.onsave.emit(true);
    } catch (error) {
      this.uiErrorHandler.handleError(error);
    } finally {
      this.savingContacts = false;
    }
  }

  async addContact() {
    const ref = this.dialog.open(AddMerchantContactDialogComponent, {
      disableClose: true,
      data: {
        merchantId: this.merchantId,
      },
    });
  
    ref.afterClosed().subscribe(() => {
      this.onsave.emit(true);
    });
  }

  editContact(contact: AssignedUser) {
    const ref = this.dialog.open(AddMerchantContactDialogComponent, {
      disableClose: true,
      data: {
        merchantId: this.merchantId,
        contact
      },
    });
  
    ref.afterClosed().subscribe(() => {
      this.onsave.emit(true);
    });
  }


  handleSaveClicked() {
    // console.log(this.contacts);
    const errors = this.validate();
    if (errors.length == 0) {
      this._updateContacts(this.contacts, this.contactsToDelete);
    }
  }

  handleContactTypeChanged(event: Event) {
    console.log(event.target);
  }

  handleCancelClicked() {
    this.contacts = this.contactsInitialState;
    this.contactsToDelete = [];
    this.editingContact = false;
  }

  _updateContacts(contacts: AssignedUser[], contactsToDelete: AssignedUser[]) {
    this.savingContacts = true;
    for (const contact of contacts) {
      //Check if the contact is new or already exists
      if (contact.userId == '') {
        this.merchantService.insertMerchantContactInfo(contact, this.merchantId).then((savedContact: AssignedUser) => {
        }).catch((message) => {this.uiErrorHandler.handleError(message);})
      } else {
        this.merchantService.patchMerchantContactInfo(contact).then((savedContact: AssignedUser) => {
        }).catch((message) => {this.uiErrorHandler.handleError(message);})
      }
    }
    for (const contact of contactsToDelete) {
      this.merchantService.deleteMerchantContactInfo(this.merchantId, contact.userId).catch((message) => {this.uiErrorHandler.handleError(message);})
    }
    this.contactDialog.open(ContactDialogComponent, {}).afterClosed().subscribe(() => {
      this.savingContacts = false;
      this.editingContact = false;
      this.onsave.emit(true);
    });
  }

  async _removeContact(contact: AssignedUser) {
    return await this.merchantService.deleteMerchantContactInfo(this.merchantId, contact.userId).catch((message) => {this.uiErrorHandler.handleError(message);})
  }

  btnEdit_click(contact: AssignedUser) {
    this.editingContact = true;
  }
}
